import { useMemo } from 'react'

import { useActiveApp, useUserContext } from 'shared/hooks'

import { useAvailableApps } from '../hooks/useAvailableApps'
import { WidgetAppTemplate } from '../templates/WidgetAppTemplate'

const AgentChatLauncherApp = () => {
  const { user } = useUserContext()
  const { apps: availableApps } = useAvailableApps()
  const activeApp = useActiveApp()

  const appProps = useMemo(
    () => ({
      user,
      availableApps,
      activeAppPath: activeApp?.app.path,
      activeAppName: activeApp?.app.name
    }),
    [user, availableApps, activeApp?.app.path, activeApp?.app.name]
  )

  return (
    <WidgetAppTemplate
      user={user}
      scope='chat_widget'
      envKey='clusterixAgentChatbox'
      entryPath='./ChatWidget'
      url={process.env.REACT_APP_CHAT_WIDGET_DEV_PATH}
      appProps={appProps}
      appName='AgentChatLauncher'
    />
  )
}

export { AgentChatLauncherApp }
